import {
    CellFormatterService,
    TableOptions
} from '../common/datatable';
import { TranslationService } from '../services/translation.service';
import { AuditModifiedFieldComponent } from './audit-modified-fields/audit-modified-field.component';
import { AuditClassFactory } from './audit-class-maker';


export class AuditOrdersTableOptions {

    options: TableOptions;

    constructor(
        private cellFormatterService: CellFormatterService,
        private translationService: TranslationService
    ) {
        this.options = this.getDefaultOptions();
    }

    getDefaultOptions(): TableOptions {

        return {
            csvFileName: 'orders-audit.csv',
            enableDetailColumn: false,
            enableDraggable: false,
            enableSelectable: false,
            enableAuditColumns: false,
            columns: [
                {
                    displayName: 'Type',
                    field: 'UpdateType',
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified Fields',
                    field: 'ModifiedFields',
                    sortField: 'ModifiedFields',
                    rendererComponent: AuditModifiedFieldComponent,
                    exportFormatter: this.cellFormatterService.auditModifiedFieldsExportFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Date',
                    field: 'ModifiedDate',
                    formatter: this.cellFormatterService.dateTimeUTCFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified By',
                    field: 'ModifiedBy',
                    formatter: this.cellFormatterService.userNameFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'ID',
                    field: 'ID',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('ID', 'ID'),
                    cellClass: AuditClassFactory.createCellClass('id'),
                },
                {
                    displayName: 'Order Type',
                    field: 'OrderType',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('OrderType', 'OrderType'),
                    cellClass: AuditClassFactory.createCellClass('ordertype'),
                },
                {
                    displayName: 'Status',
                    field: 'Status',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('Status', 'Status'),
                    cellClass: AuditClassFactory.createCellClass('status'),
                },
                {
                    displayName: 'Ordered By',
                    field: 'OrderedBy',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('OrderedBy', 'OrderedBy'),
                    cellClass: AuditClassFactory.createCellClass('orderedby'),
                },
                {
                    displayName: 'Animal/Sample Origin',
                    field: 'AnimalSampleOrigin',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('AnimalSampleOrigin', 'AnimalSampleOrigin'),
                    cellClass: AuditClassFactory.createCellClass('animalsampleorigin'),
                },
                {
                    displayName: 'Permit',
                    field: 'Permit',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('Permit', 'Permit'),
                    cellClass: AuditClassFactory.createCellClass('permit'),
                },
                {
                    displayName: 'Permit Owner',
                    field: 'PermitOwner',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('PermitOwner', 'PermitOwner'),
                    cellClass: AuditClassFactory.createCellClass('permitowner'),
                },
                {
                    displayName: this.translationService.translate('Job') + ' Name',
                    field: 'JobName',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('JobName', this.translationService.translate('Job') + 'Name'),
                    cellClass: AuditClassFactory.createCellClass((this.translationService.translate('Job') + 'Name').toLowerCase()),
                },
                {
                    displayName: 'Expected ' + this.translationService.translate('Job') + ' End Date',
                    field: 'ExpectedJobEndDate',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('ExpectedJobEndDate', 'Expected' + this.translationService.translate('Job') + 'EndDate', this.cellFormatterService.dateFormatter),
                    cellClass: AuditClassFactory.createCellClass(('Expected' + this.translationService.translate('Job') + 'EndDate').toLowerCase()),
                },
                {
                    displayName: 'Requested ' + this.translationService.translate('Line'),
                    field: 'RequestedLine',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('RequestedLine', 'Requested' + this.translationService.translate('Line')),
                    cellClass: AuditClassFactory.createCellClass('requested' + this.translationService.translate('Line').toLowerCase()),
                },
                {
                    displayName: 'Species',
                    field: 'Species',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('Species', 'Species'),
                    cellClass: AuditClassFactory.createCellClass('species'),
                },
                {
                    displayName: 'Number Of Animals Ordered',
                    field: 'NumberOfAnimalsOrdered',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('NumberOfAnimalsOrdered', 'NumberOfAnimalsOrdered'),
                    cellClass: AuditClassFactory.createCellClass('numberofanimalsordered')
                },
                {
                    displayName: 'Desired Receipt Date',
                    field: 'DesiredReceiptDate',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('DesiredReceiptDate', 'DesiredReceiptDate', this.cellFormatterService.dateFormatter),
                    cellClass: AuditClassFactory.createCellClass('desiredreceiptdate'),
                },
                {
                    displayName: 'Requested Sex',
                    field: 'RequestedSex',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('RequestedSex', 'RequestedSex'),
                    cellClass: AuditClassFactory.createCellClass('requestedsex'),
                },
                {
                    displayName: 'Requested Age Range',
                    field: 'RequestedAgeRange',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('RequestedAgeRange', 'RequestedAgeRange'),
                    cellClass: AuditClassFactory.createCellClass('requestedagerange'),
                },
                {
                    displayName: 'Requested Weight Range',
                    field: 'RequestedWeightRange',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('RequestedWeightRange', 'RequestedWeightRange'),
                    cellClass: AuditClassFactory.createCellClass('requestedweightrange'),
                },
                {
                    displayName: 'Procurement Instructions',
                    field: 'ProcurementInstructions',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('ProcurementInstructions', 'ProcurementInstructions'),
                    cellClass: AuditClassFactory.createCellClass('procurementinstructions'),
                },
                {
                    displayName: 'Housing Requirements',
                    field: 'HousingRequirements',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('HousingRequirements', 'HousingRequirements'),
                    cellClass: AuditClassFactory.createCellClass('housingrequirements'),
                },
                {
                    displayName: 'Quarantine Services Facility',
                    field: 'QuarantineServicesFacility',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('QuarantineServicesFacility', 'QuarantineServicesFacility'),
                    cellClass: AuditClassFactory.createCellClass('quarantineservicesfacility'),
                },
                {
                    displayName: 'Diet',
                    field: 'Diet',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('Diet', 'Diet'),
                    cellClass: AuditClassFactory.createCellClass('diet'),
                },
                {
                    displayName: 'Instructions',
                    field: 'Instructions',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('Instructions', 'Instructions'),
                    cellClass: AuditClassFactory.createCellClass('instructions'),
                },
                {
                    displayName: 'Food Enrichment Allowed',
                    field: 'FoodEnrichmentAllowed',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('FoodEnrichmentAllowed', 'FoodEnrichmentAllowed'),
                    cellClass: AuditClassFactory.createCellClass('foodenrichmentallowed'),
                },
                {
                    displayName: 'PO Number',
                    field: 'PONumber',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('PONumber', 'PONumber'),
                    cellClass: AuditClassFactory.createCellClass('ponumber'),
                },
                {
                    displayName: 'Vendor Order Number',
                    field: 'VendorOrderNumber',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('VendorOrderNumber', 'VendorOrderNumber'),
                    cellClass: AuditClassFactory.createCellClass('vendorordernumber'),
                },
                {
                    displayName: 'Vendor Room ID',
                    field: 'VendorRoomID',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('VendorRoomID', 'VendorRoomID'),
                    cellClass: AuditClassFactory.createCellClass('vendorroomid'),
                },
                {
                    displayName: 'Date Ordered',
                    field: 'DateOrdered',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('DateOrdered', 'DateOrdered', this.cellFormatterService.dateFormatter),
                    cellClass: AuditClassFactory.createCellClass('dateordered'),
                },
                {
                    displayName: 'Projected Receipt Date',
                    field: 'ProjectedReceiptDate',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('ProjectedReceiptDate', 'ProjectedReceiptDate', this.cellFormatterService.dateFormatter),
                    cellClass: AuditClassFactory.createCellClass('projectedreceiptdate'),
                },
                {
                    displayName: 'CITES',
                    field: 'CITES',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('CITES', 'CITES'),
                    cellClass: AuditClassFactory.createCellClass('cites'),
                },
                {
                    displayName: 'Housing',
                    field: 'Housing',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('Housing', 'Housing'),
                    cellClass: AuditClassFactory.createCellClass('housing'),
                },
                {
                    displayName: 'Water Available',
                    field: 'WaterAvailable',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('WaterAvailable', 'WaterAvailable'),
                    cellClass: AuditClassFactory.createCellClass('wateravailable'),
                },
                {
                    displayName: 'Food Available',
                    field: 'FoodAvailable',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('FoodAvailable', 'FoodAvailable'),
                    cellClass: AuditClassFactory.createCellClass('foodavailable'),
                },
                {
                    displayName: 'Bedding Available',
                    field: 'BeddingAvailable',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('BeddingAvailable', 'BeddingAvailable'),
                    cellClass: AuditClassFactory.createCellClass('beddingavailable'),
                },
                {
                    displayName: 'All Shipment Containers Confirmed Empty',
                    field: 'AllShipmentContainersConfirmedEmpty',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('AllShipmentContainersConfirmedEmpty', 'AllShipmentContainersConfirmedEmpty'),
                    cellClass: AuditClassFactory.createCellClass('allshipmentcontainersconfirmedempty'),
                },
                {
                    displayName: 'Sample Condition',
                    field: 'SampleCondition',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('SampleCondition', 'SampleCondition'),
                    cellClass: AuditClassFactory.createCellClass('samplecondition'),
                },
                {
                    displayName: 'Sample Count',
                    field: 'SampleCount',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('SampleCount', 'SampleCount'),
                    cellClass: AuditClassFactory.createCellClass('samplecount'),
                },
                {
                    displayName: 'Sample Type',
                    field: 'SampleType',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('SampleType', 'SampleType'),
                    cellClass: AuditClassFactory.createCellClass('sampletype'),
                },
                {
                    displayName: 'Accession ID',
                    field: 'AccessionID',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('AccessionID', 'AccessionID'),
                    cellClass: AuditClassFactory.createCellClass('accessionid'),
                },
                {
                    displayName: 'Locked',
                    field: 'IsLocked',
                    visible: false,
                    formatter: this.cellFormatterService.createAuditColumnFormatter('IsLocked', 'IsLocked'),
                    cellClass: AuditClassFactory.createCellClass('islocked'),
                },
                {
                    displayName: 'Created By',
                    field: 'CreatedBy',
                    formatter: this.cellFormatterService.userNameFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Created Date',
                    field: 'DateCreated',
                    formatter: this.cellFormatterService.dateTimeUTCFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                }
            ]
        };
    }
}
